import { ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react";

const STEP_LEAVE_MS = 260;

/** Keep outgoing questions briefly, but switch straight to an ending. */
export function Stage({
  stepKey,
  direction,
  renderStep,
}: {
  stepKey: string;
  direction: "forward" | "back";
  renderStep: (key: string, active: boolean) => ReactNode;
}) {
  const [leaving, setLeaving] = useState<string | null>(null);
  const lastKey = useRef(stepKey);
  const timer = useRef<any>(null);
  const ending = stepKey.startsWith("end:");

  useLayoutEffect(() => {
    if (lastKey.current !== stepKey) {
      // A card shrinks when a question becomes an ending. Do not keep the
      // old question in a clipped, animated layer over the smaller ending.
      setLeaving(ending ? null : lastKey.current);
      lastKey.current = stepKey;
      clearTimeout(timer.current);
      if (!ending) timer.current = setTimeout(() => setLeaving(null), STEP_LEAVE_MS);
    }
  }, [stepKey, ending]);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <div
      className={`sv2-stage sv2-stage--${direction} ${ending ? "sv2-stage--ending" : ""} ${
        leaving && leaving !== stepKey ? "sv2-stage--switching" : ""
      }`}
    >
      {leaving && leaving !== stepKey && (
        <div
          key={leaving}
          className="sv2-step sv2-step--leaving"
          aria-hidden="true"
          {...({ inert: "" } as any)}
        >
          {renderStep(leaving, false)}
        </div>
      )}
      <div key={stepKey} className="sv2-step sv2-step--active">
        {renderStep(stepKey, true)}
      </div>
    </div>
  );
}
